export const SET_REMINDER = "SET_REMINDER";
export const ADD_REMINDER = "ADD_REMINDER";
export const REMOVE_REMINDER = "REMOVE_REMINDER";
export const UPDATE_REMINDER = "UPDATE_REMINDER";
export const SET_CHECK_NOTIFICATION_INTERVAL = "SET_CHECK_NOTIFICATION_INTERVAL";
